/**
 * Single source for the legal/contact details that appear in the policy pages,
 * the store listing and the Play Console forms.
 *
 * Play rejects listings whose privacy policy names a different entity or a dead
 * contact address than the one on the Console account, so these values are kept
 * in one place and imported everywhere rather than retyped per page.
 *
 * BEFORE SUBMITTING: replace every value marked TODO with the real one and make
 * sure each mailbox actually receives mail - Google does test the contact route
 * for account-deletion requests.
 */
export const LEGAL = {
  appName: "TrendingZ",
  // TODO: the legal entity or individual publishing the app. Must match the
  // "Developer name" on the Play Console account.
  entity: "TrendingZ",
  site: "https://trendingz.dessot.com",

  // TODO: real, monitored mailboxes.
  supportEmail: "support@dessot.com",
  privacyEmail: "privacy@dessot.com",

  // TODO: Play requires a physical address for the developer account; it is also
  // good practice to name a jurisdiction in the terms.
  jurisdiction: "India",

  // Bump these whenever the policy text materially changes.
  effectiveDate: "29 August 2026",
  lastUpdated: "29 August 2026",
};

export const PRIVACY_URL = `${LEGAL.site}/privacy`;
export const TERMS_URL = `${LEGAL.site}/terms`;
export const DELETE_ACCOUNT_URL = `${LEGAL.site}/delete-account`;
